import jsPDF from 'jspdf'
import { decodeBase64Image } from './decodeBase64Image'

export const onDownloadPDF = (messages: any[], datasetName: string) => {
    const pdf = new jsPDF('p', 'in', 'a4')
	  
    const currentDate = new Date().toLocaleDateString()
    const headerText = `HarvestLab AI Chat History - ${currentDate}`
    pdf.setFontSize(16)
    pdf.text(headerText, 0.5, 0.5)
  
    const subHeaderText = `${datasetName}`
    pdf.setFontSize(14)
    pdf.text(subHeaderText, 0.5, 0.85)
  
    pdf.setLineWidth(0.01)
    pdf.line(0.5, 1, pdf.internal.pageSize.width - 0.5, 1)
  
    pdf.setFontSize(11)
    let currentY = 1.2 // Initial y-coordinate
  
    messages.forEach((message, index) => {
      const isUser = index % 2 === 0
  
      if (isUser) {
  
        const userText = `${message.trim()}`
        const userTextLines = pdf.splitTextToSize(userText, pdf.internal.pageSize.width - 1.5)
  
        if (currentY + userTextLines.length * 0.18 + 0.2 > pdf.internal.pageSize.height - 1) {
          pdf.addPage() // Add a new page
          currentY = 1.2 // Reset y-coordinate for the new page
        }
  
        pdf.setTextColor(0, 0, 255)
        const userLabel = 'USER: '
        pdf.text(userLabel, 0.5, currentY)
  
        pdf.setTextColor(0, 0, 0)
        pdf.text(userTextLines, 1, currentY)
        currentY += userTextLines.length * 0.18 + 0.2
      } else {
        const { image: imageString = '', message: text = '' } = JSON.parse(JSON.stringify(message))
        const decodedImage = decodeBase64Image(imageString)
  
        const aiText = `${text.trim()}`
        const aiTextLines = pdf.splitTextToSize(aiText, pdf.internal.pageSize.width - 1.5)
  
        if (currentY + aiTextLines.length * 0.18 + 0.2 > pdf.internal.pageSize.height - 1) {
          pdf.addPage() // Add a new page
          currentY = 1.2 // Reset y-coordinate for the new page
        }
  
        pdf.setTextColor(255, 98, 0)
        const aiLabel = 'AI: '
        pdf.text(aiLabel, 0.5, currentY)
  
        pdf.setTextColor(0, 0, 0)
        pdf.text(aiTextLines, 1, currentY)
        currentY += aiTextLines.length * 0.18 + 0.2
  
        // Add image to PDF
        if (imageString) {
          if (currentY > pdf.internal.pageSize.height - 2.2) {
            pdf.addPage() // Add a new page
            currentY = 1.2 // Reset y-coordinate for the new page
          }
          pdf.addImage(decodedImage, 'JPEG', 1.2, currentY, 3.2, 2.5)
          currentY += 2.8
        }
      }
    })
    pdf.save(`Chat History Report_${datasetName}.pdf`)
}
